module.exports = __webpack_public_path__ + "static/img/3343_phase_function_Paper_PointsHejduk_Prediction.634cdaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3343_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 3NPC
// module chunks = 0